import type { TFunction } from 'i18next';

export type ProjectTagId =
  | 'react'
  | 'crm'
  | 'codeIgniter'
  | 'frontend'
  | 'backend'
  | 'wordpress'
  | 'uxui'
  | 'redesign'
  | 'reservations'
  | 'presentationWeb'
  | 'leadForm'
  | 'recruitment'
  | 'menu'
  | 'orders'
  | 'gastro'
  | 'events'
  | 'campaigns'
  | 'portfolio'
  | 'personalBrand'
  | 'services'
  | 'functionalities'
  | 'construction'
  | 'health'
  | 'multilingual'
  | 'blog'
  | 'affiliate'
  | 'wellness'
  | 'customProduct';

export type ProjectItem = {
  title: string;
  category: string;
  summary: string;
  tags: ProjectTagId[];
  image: string;
  imagePosition?: string;
  arrowHoverColor?: string;
  href: string;
  external?: boolean;
};

type ProjectConfig = Omit<ProjectItem, 'category' | 'summary'> & {
  translationKey: string;
};

const PROJECT_CONFIGS: ProjectConfig[] = [
  {
    title: 'ICF House',
    translationKey: 'icfHouse',
    tags: ['react', 'leadForm', 'construction'],
    image: '/images/projects/icfhouse.webp',
    imagePosition: 'center 12%',
    arrowHoverColor: '#59D6CF',
    href: '/projekty',
  },
  {
    title: 'Boxy Nosiče',
    translationKey: 'boxyNosice',
    tags: ['wordpress', 'reservations', 'customProduct'],
    image: '/images/projects/boxynosice.webp',
    imagePosition: 'center 14%',
    arrowHoverColor: '#02F1AD',
    href: '/projekty',
  },
  {
    title: "Grey's",
    translationKey: 'greys',
    tags: ['wordpress', 'leadForm', 'health'],
    image: '/images/projects/greys.webp',
    imagePosition: 'center 12%',
    arrowHoverColor: '#5A5FB3',
    href: '/projekty',
  },
  {
    title: 'Dávid Kočan',
    translationKey: 'davidKocan',
    tags: ['wordpress', 'personalBrand', 'presentationWeb'],
    image: '/images/projects/davidkocan.webp',
    imagePosition: 'center 12%',
    arrowHoverColor: '#B4CE08',
    href: '/projekty',
  },
  {
    title: 'Glow Dent',
    translationKey: 'glowDent',
    tags: ['wordpress', 'leadForm', 'health'],
    image: '/images/projects/glowdent.webp',
    imagePosition: 'center 12%',
    arrowHoverColor: '#7ED9BA',
    href: '/projekty',
  },
  {
    title: 'Salón Sirka',
    translationKey: 'salonSirka',
    tags: ['react', 'reservations', 'services'],
    image: '/images/projects/salonsirka.webp',
    imagePosition: 'center 14%',
    arrowHoverColor: '#E8A0B5',
    href: '/projekty',
  },
  {
    title: 'Meridia',
    translationKey: 'meridia',
    tags: ['presentationWeb', 'services', 'wellness'],
    image: '/images/projects/meridia.webp',
    imagePosition: 'center 12%',
    arrowHoverColor: '#C98A57',
    href: '/projekty',
  },
  {
    title: 'Pizza Maxim',
    translationKey: 'pizzaMaxim',
    tags: ['menu', 'orders', 'gastro'],
    image: '/images/projects/pizza-maxim.webp',
    imagePosition: 'center 14%',
    arrowHoverColor: '#E30002',
    href: '/projekty',
  },
  {
    title: 'Prorok CRM',
    translationKey: 'prorokCrm',
    tags: ['codeIgniter', 'frontend', 'backend'],
    image: '/images/projects/prorokcrm.webp',
    imagePosition: 'center 12%',
    arrowHoverColor: '#7C3AED',
    href: '/projekty',
  },
  {
    title: 'Casino Zona',
    translationKey: 'casinoZona',
    tags: ['wordpress', 'blog', 'affiliate'],
    image: '/images/projects/casino-zona.webp',
    imagePosition: 'center 10%',
    arrowHoverColor: '#EF4444',
    href: '/projekty',
  },
  {
    title: 'Matronalis',
    translationKey: 'matronalis',
    tags: ['wordpress', 'multilingual', 'recruitment'],
    image: '/images/projects/matronalis.webp',
    imagePosition: 'center 10%',
    arrowHoverColor: '#2F69FF',
    href: 'https://www.matronalis.eu/',
    external: true,
  },
  {
    title: 'CREATE UP',
    translationKey: 'createUp',
    tags: ['reservations', 'presentationWeb', 'events'],
    image: '/images/projects/createup-desktop.webp',
    imagePosition: 'center 10%',
    arrowHoverColor: '#E80512',
    href: 'https://www.createup.sk/',
    external: true,
  },
];

export function getProjects(t: TFunction): ProjectItem[] {
  return PROJECT_CONFIGS.map((project) => ({
    ...project,
    category: t(`projectsData.items.${project.translationKey}.category`),
    summary: t(`projectsData.items.${project.translationKey}.summary`),
  }));
}
